import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconCompoundInterest: React.FC = () => (
    <Icon viewBox="0 0 24 24" fill="none">
        <g>
            <g>
                <ellipse
                    cx="6.75"
                    cy="3.75"
                    rx="6"
                    ry="3"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
                <line
                    x1="12.75"
                    y1="7.75"
                    x2="12.75"
                    y2="3.75"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
                <path
                    d="M.75,3.75v15c0,1.66,2.69,3,6,3a11.39,11.39,0,0,0,1.69-.12"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
                <path
                    d="M.75,15c0,1.66,2.69,3,6,3a12,12,0,0,0,1.73-.13"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
                <path
                    d="M.75,11.25c0,1.66,2.69,3,6,3a11.39,11.39,0,0,0,1.69-.12"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
                <path
                    d="M.75,7.5c0,1.66,2.69,3,6,3a12,12,0,0,0,1.73-.13"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
            </g>
            <g>
                <ellipse
                    cx="17.25"
                    cy="13"
                    rx="6"
                    ry="3"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
                <path
                    d="M11.25,13v7.25c0,1.66,2.69,3,6,3s6-1.34,6-3V13"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
                <path
                    d="M23.25,16.5c0,1.66-2.69,3-6,3s-6-1.34-6-3"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5px"
                />
            </g>
        </g>
    </Icon>
);
